import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule, Title } from '@angular/platform-browser';
import { NgModule ,ErrorHandler} from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { appRoutes } from './app.route';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { AppComponent } from './app.component';
import '../../node_modules/font-awesome/css/font-awesome.min.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'primeng/resources/themes/omega/theme.css';
import 'primeng/resources/primeng.min.css';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { CalendarModule } from 'primeng/calendar';
import { DropdownModule } from 'primeng/dropdown';
import { InputSwitchModule } from 'primeng/inputswitch';
import { RadioButtonModule } from 'primeng/radiobutton';
import { CheckboxModule } from 'primeng/checkbox';
import { TypeAheadFieldComponent } from './components/type-ahead/type-ahead-field.component';
import { AEDInputFieldComponent } from './components/aed-input-field/aed-input-field.component';
import { EmailFieldComponent } from './components/email/email.component';
import { TextFieldComponent } from './components/text/text.component';
import { NumberFieldComponent } from './components/number/number.component';
import { MobileFieldComponent } from './components/mobile/mobile.component';
import { DropdownFieldComponent } from './components/dropdown/dropdown.component';
import { ToggleComponent } from './components/toggle/toggle.component';
import { DynamicFormFieldsComponent } from './components/dynamic-form-fields/dynamic-form-fields.component';
import { HttpClientService } from './services/httpClient.service';
import { SpinnerComponent } from './components/spinner.component/spinner.component';
import { MultiSelectModule } from 'primeng/primeng';
import { SignaturePadModule } from 'angular2-signaturepad';
import { PhoneComponent, AfterIfDirective } from './components/phone/phone.component';
import { HttpAuthInterceptor } from './services/http-interceptor.service';
import { LeadFormComponent } from './components/lead-form/lead-form.component';
import {AccountConversionFormComponent} from './components/account-conversion-form/account-conversion-form.component';
import {SupportingDocAccountConversionFormComponent} from'./components/account-conversion-form/supporting-doc-account-conversion-form.component';
import { LeadFormService } from './services/lead-form.service';
import { IbanComponent } from './components/iban/iban.component';
import { TabViewModule } from 'primeng/tabview';
import { ErrorPageComponent } from './components/error-page/error-page.component';
import { CalenderFieldComponent } from './components/calender/calender.component';
import { MultiSelectDropdownComponent } from './components/multi-select-dropdown.component/multi-select-dropdown.component';
import { AuthenticationService } from './services/authentication.service';
import { CameraComponent } from './components/camera/camera.component';
import { InfoModalComponent } from '../app/components/popup-modals/info-modal/info-modal.component';
import { DocUploadService } from './services/doc-upload.service';
import { DocUploadPopupComponent } from './components/doc-upload-popup/doc-upload-popup.component';
import { PoaFormComponent } from './components/poa-form/poa-form.component';
import { PoaDocComponent } from './components/poa-form/poa-doc.component';
import { TaxFormComponent } from './components/tax-form/tax-form.component';
import { FormDocUploadPopupComponent } from './components/form-doc-upload-popup/form-doc-upload-popup.component';
@NgModule({
  declarations: [
    AppComponent,
    ToggleComponent,
     InfoModalComponent,
    DynamicFormFieldsComponent,
    AEDInputFieldComponent,
    MobileFieldComponent,
    EmailFieldComponent,
    TextFieldComponent,
    NumberFieldComponent,
    TypeAheadFieldComponent,
    DropdownFieldComponent,
    SpinnerComponent,
    PhoneComponent,
    AfterIfDirective,
    ErrorPageComponent,
    MultiSelectDropdownComponent,
    CalenderFieldComponent,
    LeadFormComponent,
    AccountConversionFormComponent,
    PoaFormComponent,
    PoaDocComponent,
    TaxFormComponent,
    SupportingDocAccountConversionFormComponent,
    IbanComponent,
    DocUploadPopupComponent,
    FormDocUploadPopupComponent,
    CameraComponent
    
  ],

  imports: [
    BrowserModule,
    PdfViewerModule,
    BrowserAnimationsModule,
    ReactiveFormsModule,
    HttpClientModule,
    RouterModule.forRoot(appRoutes, { useHash: true }),
    FormsModule,
    AutoCompleteModule,
    CalendarModule,
    DropdownModule,
    InputSwitchModule,
    RadioButtonModule,
    CheckboxModule,
    MultiSelectModule ,
    SignaturePadModule,
    TabViewModule
  ],
  providers: [
    Title,
    HttpClientService,
    AuthenticationService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpAuthInterceptor,
      multi : true
    },
    LeadFormService,
    DocUploadService
  ],
  bootstrap: [AppComponent]
})

export class AppModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/lodash/lodash.js!./~/tslint-loader!./src/app/app.module.ts